import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import logo from './elevate.png'; // Import the image from the components folder

const Navbar = () => {
  return (
    <AppBar position="fixed">
      <Toolbar>
        <Box display="flex" alignItems="center" flexGrow={1}>
          <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="LTIMindtree Logo" style={{ height: 25, marginRight: 5 }} />
          <Typography variant="h6" sx={{ color: 'white', marginRight: 1 }}>|</Typography>
          <img
            src={logo}
            alt="Gen AI Logo"
            style={{
              height: '40px',
              width: 'auto',
              marginLeft: '-5px',
              marginRight: '3px',
            }}
          />
          <Typography variant="body2" component="div" sx={{ color: 'white', marginTop: '7px' }}>
            ELEVATE
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;